import { z } from 'zod';

export const mapFormatSchema = z.object({
  name: z.string(),
  handler: z.string(),
  extension: z.string(),
  extensions: z.array(z.string()),
});
